import React, { useEffect, useState } from 'react'
import WorkFlowService from '../../../../../../libs/api/services/WorkFlowService'

const NotesContext = React.createContext()

const resolveEventId = (event) => {
    if (!event) return undefined

    if (typeof event === 'string') return event

    const directCandidates = [
        event.id,
        event.Id,
        event.ID,
        event.eventId,
        event.EventId,
        event.workflowEventId,
        event.WorkflowEventId,
        event.workFlowEventId,
        event.WorkFlowEventId,
        event.wfEventId,
        event.WFEventId,
        event.historyId,
        event.HistoryId,
        event.workflowHistoryId,
        event.WorkflowHistoryId,
        event.wfEventHistoryId,
        event.WFEventHistoryId,
    ]

    const directMatch = directCandidates.find((candidate) => candidate != null && candidate !== '')
    if (directMatch) return directMatch

    const nestedCandidates = [
        event.wfEvent,
        event.WFEvent,
        event.event,
        event.Event,
        event.workflowEvent,
        event.WorkflowEvent,
        event.workFlowHistory,
        event.WorkFlowHistory,
        event.historyEntry,
        event.HistoryEntry,
    ]

    for (const nestedValue of nestedCandidates) {
        const nestedMatch = resolveEventId(nestedValue)
        if (nestedMatch) return nestedMatch
    }

    return undefined
}

export const NotesProvider = ({ event, defaultValues, children }) => {

    const [notes, setNotes] = useState(defaultValues ? defaultValues : [])
    useEffect(() => { setNotes(defaultValues) }, [defaultValues])
    // const { event } = useContext(WorkFlowManagementContext)

    // const _handleGetNotes = () => notes
    const _handleSetNotes = (n) => setNotes(n)
    const _handleAddNote = (n) => {
        const eventId = resolveEventId(event)
        if (!eventId) {
            return Promise.reject(new Error('Workflow event id is missing'))
        }

        return WorkFlowService
            .CreateWorkFlowNote(eventId, n)
            .then((r) => setNotes([...notes, r]))
    }
    //{ setNotes([...notes, n]) }
    const _handleRemoveNote = (n) => {
        const eventId = resolveEventId(event)
        if (!eventId) {
            return Promise.reject(new Error('Workflow event id is missing'))
        }

        return WorkFlowService
            .DeleteWorkFlowNote(eventId, n)
            .then((r) => {
                if (notes) {
                    var _notes = notes; _notes.splice(_notes.indexOf(n), 1); setNotes([..._notes])
                }
            })
    }
    // { var _notes = notes; _notes.splice(_notes.indexOf(n), 1); setNotes([..._notes]) }

    return (
        <NotesContext.Provider
            value={{
                addNote: (n) => _handleAddNote(n),
                initNotes: (n) => _handleSetNotes(n),
                removeNote: (n) => _handleRemoveNote(n),
                notes: notes,
            }}
        >
            {children}
        </NotesContext.Provider>
    )
}

export default NotesContext